export const generalRoutes = ['/faq', '/about-us'];

export const withoutAuthEndpoints = [...generalRoutes, '/forgot-password', '/log-in', '/phone-verification'];
export const routesWithoutHeader = ['/totp-setup'];
export const withTmpAuthEndpoints = [
  ...generalRoutes,
  '/phone-number-validation',
  '/code-verification',
  '/phone-verification',
  '/forgot-password',
  '/log-in',
  '/totp-setup',
];

export const withFullAuthEndpoins = [
  ...generalRoutes,
  '/',
  '/dashboard',
  '/create-new-password',
  '/success-login',
  '/transactions',
  '/my-statements',
  '/money-transfers/internal',
  '/money-transfers/international',
  '/transfer',
  '/payments',
  '/payments/set-standing-order',
  '/payments/new-payment',
  '/payments/new-nra-payment',
  '/my-accounts',
  '/profile',
  '/loans',
  '/money-transfers',
  '/exchanges',
  '/sub-user-transactions',
  '/transactions-validation',
  '/transactions-pending',
  '/profile/edit-sub-user',
  '/cards',
  '/cards/prepaid-recharge',
  '/cards/prepaid-recharge/summary',
  '/alerts',
  '/deposits',
  '/saving',
  '/tickets',
  '/checkbook',
  '/totp-setup',
];

export const routesWithFooter = [...withFullAuthEndpoins, ...withTmpAuthEndpoints, ...withoutAuthEndpoints];

export const loginRoutes = [
  ...generalRoutes,
  '/log-in',
  '/forgot-password',
  '/phone-number-validation',
  '/code-verification',
  '/create-new-password',
  '/success-login',
  '/phone-verification',
  '/totp-setup',
];

export const authRoutes = [
  '/log-in',
  '/phone-number-validation',
  '/code-verification',
  '/forgot-password',
  '/phone-verification',
  '/create-new-password',
  '/success-login',
  '/totp-setup',
];
